import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useWorkspace, useWsQuery } from "@/context/WorkspaceContext";
import { DemoBadge, ErrorState, Loading } from "@/components/common";
import CommandPanel from "@/components/command/CommandPanel";
import InterpretationEditor from "@/components/command/InterpretationEditor";
import { ActiveCampaigns, ApprovalQueue, ChannelHealth, GrowthAdvisor, KpiStrip, UpcomingActivity } from "@/components/command/DashboardModules";

const LOOP = ["Command", "Plan", "Create", "Approve", "Launch", "Measure", "Learn", "Recommend", "Grow"];

export default function CommandCentre() {
  const { user } = useAuth();
  const { current } = useWorkspace();
  const [params] = useSearchParams();
  const [interp, setInterp] = useState(null);
  const q = useWsQuery("/dashboard");
  const d = q.data;

  return (
    <div className="space-y-8" data-testid="command-centre-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 cq-rise">
        <div>
          <div className="cq-label mb-3">Command Centre · {current?.name}</div>
          <h1 className="text-4xl sm:text-5xl font-semibold text-[#F7FAFF]">Good to see you, {(user?.name || "").split(" ")[0]}.</h1>
        </div>
        <div className="flex flex-wrap items-center gap-1.5 font-mono text-[10.5px] text-[#5D6B8C]" data-testid="core-loop">
          {LOOP.map((s, i) => <span key={s} className={i === 0 ? "text-[#22E6F2]" : ""}>{s}{i < LOOP.length - 1 && <span className="text-[#243153] ml-1.5">→</span>}</span>)}
        </div>
      </div>

      {interp ? <InterpretationEditor {...interp} onDiscard={() => setInterp(null)} /> : <CommandPanel onInterpreted={setInterp} autoFocus={params.get("new") === "1"} />}

      {q.isLoading ? <Loading label="Loading modules" /> : q.error ? <ErrorState message="Could not load the dashboard." onRetry={q.refetch} /> : (<>
        {current?.is_demo && <div className="flex items-center gap-3 text-xs text-[#AAB6CC]"><DemoBadge /> Campaigns, analytics, approvals and recommendations in this workspace are seeded demonstration data.</div>}
        <KpiStrip kpis={d.kpis} source={d.kpis_source} />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6 content-start">
            <ActiveCampaigns items={d.campaigns} />
            <ApprovalQueue items={d.approvals} />
            <UpcomingActivity items={d.upcoming} />
            <ChannelHealth items={d.channels} />
          </div>
          <GrowthAdvisor items={d.recommendations} />
        </div>
      </>)}
    </div>
  );
}
